import {
	Button,
	Modal,
	Paper,
	TextField,
	Typography,
	useTheme,
} from "@mui/material";
import {
	DateTimePicker,
	LocalizationProvider,
} from "@mui/x-date-pickers";
import React, { useEffect, useState } from "react";
import { InterviewTable } from "../interfaces/Interview";
import {
	DeleteInterview,
	UpdateInterview,
} from "../requester/functions";
import CommentBox from "./CommentBox";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import moment from "moment";

interface IProps {
	open: boolean;
	onClose(): void;
	onUpdate(id: number): void;
	interview?: InterviewTable;
}

const UpdateInterviewModal = (props: IProps) => {
	const theme = useTheme();

	const [interview, setInterview] = useState<InterviewTable>();

	const renderStatus = (
		item: any,
		index: number,
		selectedId: number,
		rowId: number
	) => (
		<div
			key={`status-${index}`}
			className="flex items-center w-full gap-3 rounded-lg px-1 py-1 cursor-pointer"
			style={
				selectedId === item.id
					? { border: "solid 2px", borderColor: theme.palette.primary.main }
					: {}
			}
		>
			<Typography>{item.name}</Typography>
		</div>
	);

	const onDeleteInterview = () => {
		if (interview !== undefined) {
			DeleteInterview({ id: interview?.id }, (resp) => {
				props.onClose();
			});
		}
	};

	const setInterviewDatetime = (datetime: number, interview_id: number) => {
		UpdateInterview({ datetime: datetime, id: [interview_id] }, (resp) => {
			props.onUpdate(interview_id);
		});
	};

	useEffect(() => {
		setInterview(props.interview);
	}, [props.interview]);

	return props.interview !== undefined ? (
		<Modal
			open={props.open}
			onClose={props.onClose}
			className="flex items-center flex-col justify-center overflow-auto"
		>
			<Paper className="focus-visible:outline-none p-5 max-w-[1080px] min-w-[600px] flex justify-between gap-3">
				<div className="flex flex-col">
					<div>
						<Typography variant="caption" className="!mt-3">
							Кандидат
						</Typography>
						<div className="flex items-center w-full gap-3 rounded-lg px-1 py-1">
							<Typography>{interview?.candidate.full_name}</Typography>
						</div>
					</div>
					<div>
						<Typography variant="caption" className="!mt-3">
							Вакансия
						</Typography>
						<div className="flex items-center w-full gap-3 rounded-lg px-1 py-1">
							<Typography>{interview?.vacancy.name}</Typography>
						</div>
					</div>
					<div>
						<Typography variant="caption" className="!mt-3">
							Отвественный
						</Typography>
						<div className="flex items-center w-full gap-3 rounded-lg px-1 py-1">
							<Typography>{interview?.manager?.full_name}</Typography>
						</div>
					</div>
					<div className="mt-2">
						<LocalizationProvider dateAdapter={AdapterMoment}>
							<DateTimePicker
								label="Дата и время"
								value={
									interview?.datetime
										? (moment.unix(interview?.datetime) as any)
										: null
								}
								onChange={(v) => {
									if (v) setInterviewDatetime(v.unix(), interview?.id ?? 0);
								}}
								renderInput={(params) => <TextField {...params} />}
							/>
						</LocalizationProvider>
					</div>
					<div>
						<Typography variant="caption" className="!mt-3">
							Статус
						</Typography>
						<div className="flex items-center w-full gap-3 rounded-lg px-1 py-1 cursor-pointer">
							<Typography>{interview?.status.name}</Typography>
						</div>
					</div>
					<div className="mt-auto">
						<Button onClick={() => onDeleteInterview()}>Удалить</Button>
					</div>
				</div>
				<div className="-m-5 ml-0">
					<CommentBox type="interview" id_obj={props.interview?.id ?? 0} />
				</div>
			</Paper>
		</Modal>
	) : null;
};

export default UpdateInterviewModal;
